import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import 'swiper/css';

export default function Archiveat() {
    const viewRef = useRef();
    const isInView = useInView(viewRef, { once: true });
    const variants = {
        visible: {
            opacity: 1,
            y: '0%',
            transition: {
                opacity: {
                    duration: 1.8
                },
                y: {
                    duration: 1.2
                },
                duration: 1.2,
                delay: 0.05,
                ease: 'linear'
            }
        },
        hidden: { opacity: 0, y: '50%' }
    };

    return (
        <div className="work-detail-wrap" data-hash="archiveat">
            <div className="project-cover" ref={viewRef}>
                <div className={`cover-img-wrap ${isInView && 'on'}`}>
                    <div className="phone-wrap">
                        <img
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_mockup01.webp'
                            }></img>
                    </div>
                    <div className="logo-wrap">
                        <img
                            src={
                                process.env.PUBLIC_URL + '/site/res/image/img_archiveat_logo.webp'
                            }></img>
                    </div>
                    <div className="bg-wrap">
                        <svg
                            width="1263"
                            height="866"
                            viewBox="0 0 1263 866"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M454.183 592.216C456.272 562.344 465.347 534.029 481.313 508.798C489.265 496.214 499.275 484.471 511.717 474.721C524.004 464.909 539.596 457.589 556.279 455.097C573.025 452.792 590.238 455.533 604.645 461.826C619.208 468.024 631.557 476.808 642.44 486.402C653.292 496.09 662.492 506.649 671.098 517.738C675.152 523.594 679.393 529.357 683.229 535.275L693.551 553.685C706.024 578.76 714.163 605.081 720.026 631.495C725.826 657.91 729.381 684.511 731.439 711.019C735.431 764.035 734.308 816.771 732.531 868.852V869.195C732.25 877.076 725.639 883.243 717.749 882.994C709.86 882.745 703.686 876.141 703.935 868.261C706.492 791.571 707.147 713.854 718.342 636.479C723.955 597.854 732.344 559.416 744.817 522.193C757.259 484.969 773.849 449.086 794.4 415.694C814.576 382.177 839.554 350.405 872.359 326.856C888.918 315.424 907.784 306.515 928.085 302.84C938.251 301.438 948.698 300.597 958.77 301.968C963.791 302.715 968.905 302.933 973.863 304.117L988.613 308.073C1007.88 314.801 1025.19 326.264 1039.32 340.468C1053.51 354.672 1064.73 371.368 1073.53 389.03C1090.62 424.664 1099.04 463.788 1099 502.974V503.036C1099 505.372 1097.1 507.272 1094.76 507.272C1092.42 507.272 1090.52 505.372 1090.52 503.036C1090.86 470.485 1091.55 437.778 1095.6 405.321C1099.63 372.895 1107.45 340.624 1121.33 310.876C1128.35 296.112 1137.64 281.845 1150.77 271.535C1163.8 261.287 1179.99 255.151 1196.52 254.465C1204.75 254.216 1213.11 255.431 1220.81 258.421C1228.51 261.411 1235.43 266.177 1241.23 271.909C1253.18 283.309 1259.85 299.04 1263 314.863C1259.51 299.071 1252.52 283.621 1240.52 272.656C1234.65 267.112 1227.79 262.657 1220.25 259.885C1212.7 257.144 1204.59 256.147 1196.61 256.552C1180.64 257.549 1165.05 263.872 1152.8 273.965C1140.45 284.119 1131.78 298.012 1125.2 312.621C1112.19 342.15 1105.21 373.954 1101.94 406.006C1098.63 438.121 1098.66 470.516 1099.04 502.974H1090.55C1089.77 465.221 1080.7 427.437 1063.73 393.982C1055 377.411 1044.09 361.992 1030.77 349.252C1017.49 336.481 1001.68 326.576 984.403 320.938L971.181 317.698C966.753 316.732 962.138 316.67 957.647 316.078C948.604 314.988 939.654 316.016 930.798 317.386C913.179 321 896.589 329.161 881.715 339.908C852.215 362.055 828.951 392.55 810.334 425.225C791.219 457.839 776.063 492.632 764.868 528.672C753.642 564.743 746.345 601.966 741.699 639.625C732.437 715.037 733.404 791.758 732.531 868.884L703.935 868.261C704.59 816.273 704.528 764.658 699.569 713.854C697.043 688.498 693.083 663.423 687.189 639.127C681.264 614.862 673.281 591.282 662.055 569.882L652.949 554.401C649.581 549.511 645.964 544.869 642.534 540.041C634.987 530.728 626.786 521.757 617.992 514.281C609.198 506.836 599.812 500.7 590.238 496.899C580.665 492.975 571.123 492.071 562.079 493.411C543.962 496.37 526.966 511.104 515.584 530.229C503.984 549.261 497.248 572.218 496.25 594.303V594.615C495.72 606.233 485.866 615.267 474.203 614.737C462.572 614.207 453.528 604.364 454.058 592.746C454.058 592.59 454.058 592.341 454.058 592.216H454.183Z"
                                fill="white"
                            />
                            <path
                                d="M1002.08 557.514C998.623 472.508 990.702 387.471 972.241 304.77C963.073 263.435 951.254 222.754 935.974 183.506C928.521 163.819 920.008 144.631 910.185 126.316C900.362 108.031 889.136 90.5564 875.789 75.2933C862.505 60.0302 847.069 46.9786 829.762 38.2568C812.517 29.4416 793.308 25.3922 774.192 26.3578C755.17 27.23 736.803 33.4288 720.587 43.5834C704.34 53.7069 690.214 67.5371 678.458 83.2363C666.701 98.9667 657.284 116.628 650.33 135.1L647.741 142.015L645.621 149.086L643.532 156.157L641.879 163.414C639.509 173.258 637.669 183.443 635.892 193.723C628.938 234.715 624.509 276.393 625.195 316.949V317.136C625.383 328.786 616.09 338.38 604.458 338.567C592.795 338.753 583.191 329.471 583.004 317.821C583.004 317.541 583.004 317.198 583.004 316.949C584.157 272.343 590.644 229.233 599.656 186.683C601.963 176.061 604.365 165.408 607.389 154.661L609.635 146.469L612.41 138.339L615.248 130.241L618.553 122.36C627.472 101.365 639.135 81.5854 653.604 63.768C668.073 46.013 685.474 30.1892 705.931 18.6017C726.294 6.98301 749.9 0.0991196 773.569 0.0056719C797.081 -0.212373 820.687 5.86169 840.926 17.2935C861.258 28.6006 878.159 44.4555 892.099 61.8368C906.1 79.2492 917.17 98.3749 926.682 117.937C936.161 137.561 944.113 157.714 950.911 178.117C964.851 218.829 975.11 260.6 982.625 302.714C997.812 387.004 1002.15 472.477 1002.12 557.546L1002.08 557.514Z"
                                fill="white"
                            />
                            <path
                                d="M335.996 142.108C340.829 119.93 349.498 98.0634 363.905 79.187C371.14 69.811 379.84 61.3385 389.788 54.5168C394.746 51.0593 400.048 48.1622 405.474 45.608C410.962 43.4276 416.482 41.5275 421.97 39.5962C427.614 38.0388 433.57 37.1977 439.308 36.0764C445.202 35.6091 451.158 35.6092 457.021 35.5469C462.852 36.3879 468.746 36.8553 474.39 38.1947L482.716 40.6554C485.492 41.4653 488.267 42.2752 490.793 43.5834C511.935 52.4298 529.211 66.7274 543.307 82.7692C557.402 98.9045 568.534 117.033 577.016 136.19C581.32 145.753 584.75 155.689 587.463 165.782C590.145 175.812 592.172 185.748 594.074 195.81C601.433 235.992 603.741 276.611 603.99 316.98C600.248 276.767 594.386 236.74 583.783 198.177C581.101 188.583 578.232 178.927 574.865 169.707C571.528 160.58 567.568 151.64 562.796 143.167C553.441 126.16 541.716 110.461 528.026 97.3158C514.368 84.202 498.526 73.6425 481.718 68.3471C479.66 67.4749 477.54 67.0699 475.388 66.6961L469.058 65.3879C464.817 64.7649 460.544 64.9206 456.366 64.578C452.156 65.1075 448.008 65.4501 443.892 66.1043C439.838 67.4125 435.753 68.2537 431.793 69.7177C415.39 75.7918 403.104 86.4448 393.998 100.649C385.048 114.822 379.778 131.892 377.564 149.366C376.13 160.923 365.558 169.115 353.989 167.682C342.42 166.249 334.218 155.689 335.653 144.133C335.715 143.51 335.84 142.918 335.965 142.326V142.233L335.996 142.108Z"
                                fill="white"
                            />
                            <path
                                d="M581.164 320.094C577.609 296.265 564.262 273.869 544.367 263.06C539.44 260.475 534.232 258.543 528.931 257.297C523.536 256.269 518.297 255.989 512.123 256.363C500.21 257.36 488.205 260.942 477.165 266.954C466.064 272.872 455.898 281.064 447.354 290.689C438.716 300.252 431.949 311.435 426.336 323.801C415.172 348.596 409.216 376.91 403.416 405.817L403.322 406.346C401.7 414.445 393.78 419.709 385.672 418.09C378.936 416.75 374.196 411.081 373.666 404.571C372.263 386.816 369.706 369.684 365.059 353.019C360.506 336.447 353.708 319.689 346.349 303.71C338.865 287.948 329.915 273.246 318.377 261.503C306.964 249.728 292.557 241.287 276.684 236.739C260.999 232.347 243.816 232.316 227.102 235.711C218.744 237.393 210.481 239.885 202.435 243.062C198.413 244.62 194.483 246.489 190.585 248.451C186.594 250.227 182.852 252.5 179.047 254.65C148.674 272.249 123.727 298.882 103.333 328.38C82.7826 357.972 66.8164 390.896 52.8772 424.537C38.938 458.21 28.0548 493.19 19.8846 528.794C3.35715 600.001 -1.1957 674.105 5.94542 747.243C-3.69041 674.416 -1.69464 599.783 12.5252 527.268C19.5728 491.01 29.3645 455.188 42.3682 420.488C55.3719 385.85 70.4649 351.68 90.7968 320.094C111.004 288.665 136.45 259.229 169.256 238.639C173.372 236.116 177.426 233.499 181.76 231.35C186.001 229.045 190.336 226.833 194.795 224.902C203.745 221.009 213.038 217.862 222.611 215.557C241.727 210.979 262.371 210.075 282.328 214.934C302.037 219.731 320.747 229.917 335.435 244.059C350.216 258.107 361.068 274.99 369.893 292.06C378.468 309.161 386.171 326.324 392.065 345.014C397.958 363.579 401.451 382.829 403.571 401.643L373.822 400.397C378.749 371.148 383.738 340.653 395.9 310.749C401.981 295.922 410.214 281.095 421.003 268.231C431.699 255.335 444.578 244.121 459.36 235.524C474.078 226.833 490.855 220.946 508.443 218.921C517.05 217.987 526.748 218.018 535.978 219.576C545.209 221.289 554.096 224.279 562.422 228.36C570.624 232.627 578.233 237.829 585.031 243.872C591.642 250.04 597.785 256.768 602.774 264.213C612.971 278.977 619.395 295.829 622.732 313.023C624.977 324.455 617.493 335.513 606.049 337.756C594.604 339.999 583.534 332.523 581.289 321.091C581.226 320.81 581.195 320.53 581.133 320.25V320.094H581.164Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </div>

                <div className="cover-text-wrap">
                    <div className="container">
                        <h2 className="project-type">Public Kitchen</h2>
                        <h4 className="project-name">ARCHIVEAT</h4>
                        <ul className="project-team">
                            <li className="team-tag">design</li>
                            <li className="team-tag">Project Management</li>
                            <li className="team-tag">development</li>
                        </ul>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            className="project-desc">
                            <motion.p variants={variants}>
                                아카이빗은 공공의 주방이 보유한 수천만가지의 레시피를 영상과 함께
                                제공하고, 매주 큐레이션된 쿠킹박스를 정기배송 받아볼 수 있는
                                플랫폼입니다.
                                <br />
                                <br />
                                홈 화면은 영역 별로 다섯가지 이상의 템플릿을 제공하여 보다
                                다이나믹하게 콘텐츠가 보여질 수 있도록 구성하였습니다. 유저들의
                                서비스 이용 시간을 증가시킬 수 있도록 태그 및 테마 기반으로 관련
                                콘텐츠를 추천하며, 회원 및 멤버십 가입 여부에 따라 열람 가능
                                콘텐츠와 사용 기능에 제한을 두어 멤버십 가입을 유도할 수 있습니다.
                                또한 아카이빗의 다양한 콘텐츠들을 한눈에 확인하고 아카이빙 할 수
                                있도록 검색 피드와 아카이브 기능을 함께 제공합니다.
                                <br />
                                <br />
                                아카이빗은 레시피와 함께 해당 레시피에 대한 재료를 집 앞까지
                                배송해주는 쿠킹박스 정기배송 서비스를 운영합니다. 매 주 2번의 요일
                                중 원하는 요일을 지정하여, 다양한 쿠킹박스와 상품을 고르거나 배송을
                                SKIP 할 수 있습니다. 4주간의 배송 일정과 상품을 미리 지정할 수
                                있도록 주차별 커스텀 화면을 구성하여 유저들의 서비스 이해도와
                                편의성을 증대시킬 수 있도록 하였습니다.
                            </motion.p>
                        </motion.div>
                    </div>
                </div>
            </div>

            <div className="project-contents dark">
                <section className="cont-sec-01">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="cont-img-01 fade-up">
                        <motion.div variants={variants} className="reactive"></motion.div>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="cont-img-02 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_01_02_mobile.webp 184w',
                                process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_01_02.webp 491w')
                            }
                            sizes="(max-width: 500px) 184px,
                                491px"
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_01_02.webp'
                            }
                        />
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="img-slide fade-up">
                        <motion.ul variants={variants}>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_01_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_01.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_01.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_02_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_02.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_02.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_03_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_03.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_03.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_04_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_04.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_04.web'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_05_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_05.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_05.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_06_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_06.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_06.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_07_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_07.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_07.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                        </motion.ul>
                        <motion.ul variants={variants}>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_01_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_01.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_01.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_02_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_02.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_02.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_03_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_03.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_03.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_04_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_04.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_04.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_05_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_05.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_05.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_06_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_06.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_06.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_07_mobile.webp 154w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_01_slide_07.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_01_slide_07.webp'
                                    }
                                    sizes="(max-width: 767px) 154px, 327px"
                                />
                            </li>
                        </motion.ul>
                    </motion.div>
                </section>

                <section className="cont-sec-02">
                    <motion.div
                        className="cont-wrap fade-up"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}>
                        <motion.div variants={variants} className="cont-wrap-01">
                            <div className="cont-img-01 reactive"></div>

                            <div className="cont-img-02">
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_02_scrollview_mobile.webp 200w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_02_scrollview.webp 480w')
                                    }
                                    sizes="(max-width: 500px) 200px,
                                    480px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_02_scrollview.webp'
                                    }
                                />
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_02_scrollview_mobile.webp 200w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_02_scrollview.webp 480w')
                                    }
                                    sizes="(max-width: 500px) 200px,
                                    480px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_02_scrollview.webp'
                                    }
                                />
                            </div>
                        </motion.div>
                    </motion.div>
                </section>

                <section className="cont-sec-03">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="cont-img-01 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_03_01_mobile.webp 296w',
                                process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_03_01.webp 491w')
                            }
                            sizes="(max-width: 500px) 296px,
                                491px"
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_03_01.webp'
                            }
                        />
                    </motion.div>

                    <div className="img-slide">
                        <ul>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_01_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_01.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_01.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_02_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_02.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_02.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_03_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_03.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_03.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_04_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_04.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_04.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_05_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_05.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_05.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_06_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_06.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_06.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_07_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_07.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_07.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_01_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_01.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_01.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_02_mobile.webp 156w',
                                        process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_02.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_02.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_03_mobile.webp 156w',
                                        '/site/res/image/img_archiveat_section_03_slide_03.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_03.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_04_mobile.webp 156w',
                                        '/site/res/image/img_archiveat_section_03_slide_04.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_04.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_05_mobile.webp 156w',
                                        '/site/res/image/img_archiveat_section_03_slide_05.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_05.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_06_mobile.webp 156w',
                                        '/site/res/image/img_archiveat_section_03_slide_06.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_06.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                            <li>
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_03_slide_07_mobile.webp 156w',
                                        '/site/res/image/img_archiveat_section_03_slide_07.webp 327w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_03_slide_07.webp'
                                    }
                                    sizes="(max-width: 767px) 156px, 327px"
                                />
                            </li>
                        </ul>
                    </div>
                </section>

                <section className="cont-sec-04">
                    <div className="cont-wrap-01 d-flex stretch">
                        <div className="cont-img-01">
                            <img
                                srcSet={
                                    (process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_04_01_mobile.webp 360w',
                                    '/site/res/image/img_archiveat_section_04_01.webp 960w')
                                }
                                src={
                                    process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_04_01.webp.webp'
                                }
                                sizes="(max-width: 767px) 360px, 960px"
                            />
                        </div>
                        <div className="cont-img-02">
                            <div className="cont-img-container">
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_04_02.webp 130w',
                                        '/site/res/image/img_archiveat_section_04_02.webp 960w')
                                    }
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_04_02.webp'
                                    }
                                    sizes="(max-width: 767px) 130px, 960px"
                                />
                                <video
                                    id="autoplayVideo"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/archiveat_section04.mp4'
                                    }
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    poster="">
                                    <source
                                        src={
                                            process.env.PUBLIC_URL +
                                            '/site/res/image/archiveat_section04.mp4'
                                        }
                                        type="video/mp4"></source>
                                </video>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cont-sec-05">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="fade-up">
                        <motion.div className="cont-wrap-01" variants={variants}>
                            <div className="cont-img-mockup reactive"></div>
                            <div className="cont-img-scrollview">
                                <img
                                    srcSet={
                                        (process.env.PUBLIC_URL +
                                            '/site/res/image/img_archiveat_section_05_01_scrollview_mobile.webp 140w',
                                        '/site/res/image/img_archiveat_section_05_01_scrollview.webp 375w')
                                    }
                                    sizes="(max-width: 500px) 140px,
                                    375px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_05_01_scrollview.webp'
                                    }
                                />
                            </div>
                        </motion.div>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="fade-up">
                        <motion.div variants={variants} className="cont-wrap-02">
                            <div className="cont-img-mockup reactive"></div>
                            <div className="cont-img-slide">
                                <div className="swiper-container">
                                    <Swiper
                                        slidesPerView={1}
                                        autoplay={{
                                            delay: 3000,
                                            disableOnInteraction: false
                                        }}
                                        speed={1500}
                                        loop={true}
                                        modules={[Autoplay]}>
                                        <SwiperSlide>
                                            <img
                                                srcSet={
                                                    (process.env.PUBLIC_URL +
                                                        '/site/res/image/img_archiveat_section_05_02_mobile.webp 296w',
                                                    '/site/res/image/img_archiveat_section_05_02_slide_01.webp 375w')
                                                }
                                                sizes="(max-width: 500px) 296px,
                                                375px"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/site/res/image/img_archiveat_section_05_02_slide_01.webp'
                                                }
                                            />
                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <img
                                                srcSet={
                                                    (process.env.PUBLIC_URL +
                                                        '/site/res/image/img_archiveat_section_05_02_mobile.webp 296w',
                                                    '/site/res/image/img_archiveat_section_05_02_slide_02.webp 375w')
                                                }
                                                sizes="(max-width: 500px) 296px,
                                                375px"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/site/res/image/img_archiveat_section_05_02_slide_02.webp'
                                                }
                                            />
                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <img
                                                srcSet={
                                                    (process.env.PUBLIC_URL +
                                                        '/site/res/image/img_archiveat_section_05_02_mobile.webp 296w',
                                                    '/site/res/image/img_archiveat_section_05_02_slide_03.webp 375w')
                                                }
                                                sizes="(max-width: 500px) 296px,
                                                375px"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/site/res/image/img_archiveat_section_05_02_slide_03.webp'
                                                }
                                            />
                                        </SwiperSlide>
                                    </Swiper>
                                    {/* <div className="swiper-wrapper">
                                        <div className="swiper-slide">
                                            <img
                                                srcSet={
                                                    (process.env.PUBLIC_URL +
                                                        '/site/res/image/img_archiveat_section_05_02_mobile.webp 296w',
                                                    '/site/res/image/img_archiveat_section_05_02_slide_01.webp 375w')
                                                }
                                                sizes="(max-width: 500px) 296px,
                                                375px"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/site/res/image/img_archiveat_section_05_02_slide_01.webp'
                                                }
                                            />
                                        </div>
                                        <div className="swiper-slide">
                                            <img
                                                srcSet={
                                                    (process.env.PUBLIC_URL +
                                                        '/site/res/image/img_archiveat_section_05_02_mobile.webp 296w',
                                                    '/site/res/image/img_archiveat_section_05_02_slide_02.webp 375w')
                                                }
                                                sizes="(max-width: 500px) 296px,
                                                375px"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/site/res/image/img_archiveat_section_05_02_slide_02.webp'
                                                }
                                            />
                                        </div>
                                        <div className="swiper-slide">
                                            <img
                                                srcSet={
                                                    (process.env.PUBLIC_URL +
                                                        '/site/res/image/img_archiveat_section_05_02_mobile.webp 296w',
                                                    '/site/res/image/img_archiveat_section_05_02_slide_03.webp 375w')
                                                }
                                                sizes="(max-width: 500px) 296px,
                                                375px"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/site/res/image/img_archiveat_section_05_02_slide_03.webp'
                                                }
                                            />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </section>

                <section className="cont-sec-06">
                    <div className="cont-img-01">
                        <div className="reactive"></div>
                    </div>
                </section>

                <section className="cont-sec-07">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-01 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_01_mobile.webp 48w',
                                '/site/res/image/img_archiveat_section_07_bg_01.webp 256w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_01.webp.webp'
                            }
                            sizes="(max-width: 767px) 48px, 256px"
                        />
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-02 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_02_mobile.webp 46w',
                                '/site/res/image/img_archiveat_section_07_bg_02.webp 239w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_02.webp.webp'
                            }
                            sizes="(max-width: 767px) 46px, 239px"
                        />
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-03 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_03_mobile.webp 59w',
                                '/site/res/image/img_archiveat_section_07_bg_03.webp 252w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_03.webp.webp'
                            }
                            sizes="(max-width: 767px) 59px, 252px"
                        />
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-04 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_04_mobile.webp 49w',
                                '/site/res/image/img_archiveat_section_07_bg_04.webp 234w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_04.webp.webp'
                            }
                            sizes="(max-width: 767px) 49px, 234px"
                        />
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-05 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_05_mobile.webp 123w',
                                '/site/res/image/img_archiveat_section_07_bg_05.webp 508w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_05.webp.webp'
                            }
                            sizes="(max-width: 767px) 123px, 508px"
                        />
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-06 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_06_mobile.webp 114w',
                                '/site/res/image/img_archiveat_section_07_bg_06.webp 470w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_06.webp.webp'
                            }
                            sizes="(max-width: 767px) 114px, 470px"
                        />
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="bg-img-07 fade-up">
                        <motion.img
                            variants={variants}
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_bg_07_mobile.webp 105w',
                                '/site/res/image/img_archiveat_section_07_bg_07.webp 476w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_07_bg_07.webp.webp'
                            }
                            sizes="(max-width: 767px) 105px, 476px"
                        />
                    </motion.div>
                    <div className="cont-wrap-01">
                        <div className="cont-img-mockup reactive"></div>
                        <div className="cont-img-scrollview">
                            <img
                                srcSet={
                                    (process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_07_scrollview_mobile.webp 160w',
                                    '/site/res/image/img_archiveat_section_07_scrollview.webp 375w')
                                }
                                src={
                                    process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_07_scrollview.webp.webp'
                                }
                                sizes="(max-width: 767px) 160px, 375px"
                            />
                        </div>
                    </div>
                </section>

                <section className="cont-sec-08">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="fade-up">
                        <motion.div variants={variants} className="cont-wrap-01 d-flex">
                            <div className="cont-img-01">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_01.webp'
                                    }
                                />
                            </div>
                            <div className="cont-img-02">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_02.webp'
                                    }
                                />
                            </div>
                        </motion.div>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="fade-up">
                        <motion.div variants={variants} className="cont-wrap-02 d-flex">
                            <div className="cont-img-03">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_03.webp'
                                    }
                                />
                            </div>
                            <div className="cont-img-04">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_04.webp'
                                    }
                                />
                            </div>
                        </motion.div>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="fade-up">
                        <motion.div variants={variants} className="cont-wrap-03 d-flex">
                            <div className="cont-img-05">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_05.webp'
                                    }
                                />
                            </div>
                        </motion.div>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="fade-up">
                        <motion.div variants={variants} className="cont-wrap-04 d-flex">
                            <div className="cont-img-06">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_06.webp'
                                    }
                                />
                            </div>
                            <div className="cont-img-07">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/site/res/image/img_archiveat_section_08_07.webp'
                                    }
                                />
                            </div>
                        </motion.div>
                    </motion.div>
                </section>

                <section className="cont-sec-09">
                    <div className="cont-img-01">
                        <img
                            srcSet={
                                (process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_09_01_mobile.webp 360w',
                                process.env.PUBLIC_URL +
                                    '/site/res/image/img_archiveat_section_09_01.webp 1920w')
                            }
                            src={
                                process.env.PUBLIC_URL +
                                '/site/res/image/img_archiveat_section_09_01.webp.web'
                            }
                            sizes="(max-width: 767px) 360px, 1920px"
                        />
                    </div>
                </section>
            </div>
        </div>
    );
}
